import { Component, Input } from '@angular/core';
import { IScreeningDivergenceReportResponse } from '../../models';

@Component({
  selector: 'app-divergence-report-content',
  templateUrl: './divergence-report-content.component.html',
  styleUrls: ['./divergence-report-content.component.sass']
})
export class DivergenceReportContentComponent {
  @Input() data: IScreeningDivergenceReportResponse;
  reportDate = new Date();
}
